const mobileMenuBtn = document.getElementById("mobileMenuBtn");
const mobileMenu = document.getElementById("mobileMenu");
const menuIcon = document.getElementById("menuIcon");

function toggleMobileMenu() {
  const isOpen = mobileMenu.classList.toggle("is-shown");

  if (isOpen) {
    mobileMenuBtn.classList.add("is-triggered");
    menuIcon.classList.add("is-active");
    document.documentElement.classList.add("overflow-y-hidden");
  } else {
    mobileMenuBtn.classList.remove("is-triggered");
    menuIcon.classList.remove("is-active");
    document.documentElement.classList.remove("overflow-y-hidden");
  }
}

mobileMenuBtn.addEventListener("click", toggleMobileMenu);
